import React from 'react';
import { Box, Text, VStack } from '@gluestack-ui/themed';

class ModuleTaskPreviewErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || 'Unknown preview error',
    };
  }

  componentDidCatch(error, errorInfo) {
    // [AI-DEBUG] Remove after issue is resolved.
    // Keep payload small and string-safe for browser consoles.
    console.error(`[AI-DEBUG] ModuleTaskPreviewErrorBoundary label=${this.props?.label || 'root'}`);
    console.error('[AI-DEBUG] ModuleTaskPreviewErrorBoundary caught error', {
      label: this.props?.label || null,
      message: error?.message,
      name: error?.name,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
      taskId: this.props?.task?.id || null,
      taskType: this.props?.task?.type || null,
      eventKindId: this.props?.task?.eventConfig?.eventKindId || null,
      moduleId: this.props?.module?.id || null,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box p="$4" bg="$backgroundLight50" borderWidth={1} borderColor="$error200" borderRadius="$md">
          <VStack space="xs">
            <Text size="sm" color="$error700" fontWeight="semibold">
              Task preview failed to render
            </Text>
            {!!this.props?.label && (
              <Text size="xs" color="$textLight600">
                Section: {this.props.label}
              </Text>
            )}
            <Text size="xs" color="$textLight600">
              {this.state.errorMessage}
            </Text>
            <Text size="xs" color="$textLight500">
              Open browser console and search for [AI-DEBUG] ModuleTaskPreviewErrorBoundary.
            </Text>
          </VStack>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ModuleTaskPreviewErrorBoundary;
